import qs from "qs";
import environment from "environment";
import type {
  Filters,
  Sorting,
} from "@fas/cpa-state-manager/redux/actions/table";
import { requestService } from "../request";
import type { ActiveBrandsPayloadItem } from "../../containers/ActiveBrands/types/ActiveBrands.types";

type Options = {
  page: number,
  limit: number,
  filters: Filters,
  sorting: Sorting,
  headers: string[],
}

export type Data = {
  "data": ActiveBrandsPayloadItem[],
  "count": number,
}

export const getActiveBrands = (options: Options) => {
  const [[current, direction] = []] = Object.entries(options.sorting);

  return requestService
    .get(environment.endpoints.get.getActiveBrands, {
      params: { ...options },
      paramsSerializer: (params): string => qs.stringify({
        ...params,
        filters: Object.keys(params.filters).length ? params.filters : JSON.stringify({}),
        sorting: current ? {
          current,
          direction,
        } : JSON.stringify({}),
        headers: params.headers.length ? params.headers : JSON.stringify([]),
      }, { arrayFormat: "brackets", encode: true }),
    });
};
